import { AxiosCallPostWithErr2 } from './apicall'
import { LynxUtils } from '@/utils'
import FindKeyConstants from '@/utils/FindKeyConstants.js'

/**
 * Service top operate on opportunities
 */
export default class OppService {
  /**
   * Constructor.
   * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
   */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  async findMatchingOpps (filter) {
    const fr = {
      SearchKeys: {
      }
    }
    if (filter.SelectedOppStates) {
      fr.SearchKeys[FindKeyConstants.FR_OPP_STATES] = LynxUtils.CreateIdListFromList(filter.SelectedOppStates)
    }
    if (filter.SelectedPositionTypes) {
      fr.SearchKeys[FindKeyConstants.FR_POSITION_TYPES] = LynxUtils.CreateIdListFromList(filter.SelectedPositionTypes)
    }
    if (filter.SelectedSkills) {
      fr.SearchKeys[FindKeyConstants.FR_SKILLS1] = LynxUtils.CreateIdListFromList(filter.SelectedSkills)
      fr.SearchKeys[FindKeyConstants.FR_COMBINE_SKILLS1] = filter.Allskills
    }
    if (filter.SelectedSales) {
      const contids = LynxUtils.CreateIdListFromObjectsWithProp(filter.SelectedSales, 'contactId')
      fr.SearchKeys[FindKeyConstants.FR_OPPSALESSUPERV] = contids
    }
    if (filter.SelectedIssuer) {
      fr.SearchKeys[FindKeyConstants.FR_ISSUER] = filter.SelectedIssuer.contactId
    }
    const res = await AxiosCallPostWithErr2('lynxapi/opp/findopps', fr)
    if (res == null) {
      return null
    }
    return {result: res.result, count: res.count}
  }

  async findLastActivityForOpp (oppid) {
    const res = await AxiosCallPostWithErr2('lynxapi/opp/findLastActivityForOpp', {id: oppid})
    if (res == null) {
      return null
    }
    return res.result
  }
}
